import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SetCursorPositionRightCommand from './setcursorpositionrightcommand.js';
import SetCursorPositionRightEditing from './setcursorpositionrightediting.js';

export default class NumberedCitation extends Plugin {
  static get pluginName() {
    return 'SetCursorPositionRight';
  }
  static get requires() {
    return [ SetCursorPositionRightEditing, SetCursorPositionRightCommand ];
  }
}